// Maintained catalog includes indicators excluded by the legacy folder-name compiler.
import Legacy from './overlay_prod'
import AdditionalBuiltins from './workspace/additional-builtins'
import ADL from './overlays/ADL/ADL.vue'
import Aroon from './overlays/AroonIndicator/AroonIndicator.vue'
import BollingerPercentB from './overlays/BollingerPercentB/BollingerPercentB.vue'
import ChaikinOscillator from './overlays/ChaikinOscillator/ChaikinOscillator.vue'
import ChaikinVolatility from './overlays/ChaikinVolatility/ChaikinVolatility.vue'
import ChoppinessIndex from './overlays/ChoppinessIndex/ChoppinessIndex.vue'
import DPO from './overlays/DPO/DPO.vue'
import EaseOfMovement from './overlays/EaseOfMovement/EaseOfMovement.vue'
import ForceIndex from './overlays/ForceIndex/ForceIndex.vue'
import HistoricalVolatility from './overlays/HistoricalVolatility/HistoricalVolatility.vue'
import MassIndex from './overlays/MassIndex/MassIndex.vue'
import MedianPrice from './overlays/MedianPriceIndicator/MedianPriceIndicator.vue'
import NVI from './overlays/NVI/NVI.vue'
import OBV from './overlays/OBV/OBV.vue'
import PVI from './overlays/PVI/PVI.vue'
import SupportResistanceTable from './overlays/SupportResistanceTable/SupportResistanceTable.vue'
import TRIX from './overlays/TRIXIndicator/TRIXIndicator.vue'
import TypicalPrice from './overlays/TypicalPriceIndicator/TypicalPriceIndicator.vue'
import UlcerIndex from './overlays/UlcerIndex/UlcerIndex.vue'
import UltimateOscillator from './overlays/UltimateOscillatorIndicator/UltimateOscillatorIndicator.vue'
import VTTargetsTable from './overlays/VTTargetsTable/VTTargetsTable.vue'
import Vortex from './overlays/Vortex/Vortex.vue'
import WeightedClose from './overlays/WeightedCloseIndicator/WeightedCloseIndicator.vue'

import PPO from './overlays/PPO/PPO.vue'
import ElderRay from './overlays/ElderRay/ElderRay.vue'
import DonchianWidth from './overlays/DonchianWidth/DonchianWidth.vue'
import PriceEfficiency from './overlays/PriceEfficiency/PriceEfficiency.vue'

const catalog = { ...Legacy, ...AdditionalBuiltins, PPO, ElderRay, DonchianWidth, PriceEfficiency, ADL, Aroon, BollingerPercentB, ChaikinOscillator, ChaikinVolatility, ChoppinessIndex, DPO, EaseOfMovement, ForceIndex, HistoricalVolatility, MassIndex, MedianPrice, NVI, OBV, PVI, SupportResistanceTable, TRIX, TypicalPrice, UlcerIndex, UltimateOscillator, VTTargetsTable, Vortex, WeightedClose }

import {indicatorContract} from './workspace/indicator-contracts.mjs'
const protectedTypes = /^(VT|VTLaser|VTCandles|VisualCandles|VisualTrading|VTConfidence|VTTargetsTable|MTFTargets|LSR|LT|MTA|MakersMove|TimeCycle)$/
for (const overlay of Object.values(catalog)) {
    if(!overlay.methods?.calc || protectedTypes.test(overlay.name))continue
    const calculate=overlay.methods.calc
    overlay.methods.calc=function(){return indicatorContract(overlay.name,calculate.call(this))}
}
export default catalog
